import { defaults, omitBy } from 'lodash';

export function kDefaults(a: any, b: any) {
    return defaults(
        omitBy(a, (o) => o === '' || o === null || o === '[]' || (Array.isArray(o) && o.length === 0)),
        omitBy(b, (o) => o === '' || o === null || o === '[]' || (Array.isArray(o) && o.length === 0)),
    );
}
